<template>
    <b-icon-question-circle v-if="text"
                            class="helper no-print"
                            @click="edit"
                            v-b-popover.hover.right="{content: text, html: true}"/>
    <b-icon-question-circle-fill v-else-if="canEdit"
                                 class="helper no-print"
                                 @click="edit"/>
</template>

<script>
export default {
    props: {
        tag: {
            type: String,
            required: true
        },
    },
    data () {
        return {
            id: null,
            text: null,
            canEdit: false,
        }
    },
    mounted () {
        //  set admin flag
        this.canEdit = this.$user.isSuperAdmin() || this.$user.isAdmin()
        //  retrieve help text
        if (this.tag) {
            // check cache first
            let text = this.$store.state.helps ? this.$store.state.helps[this.tag] : null
            if (text || (text === null)) {
                this.text = text
            } else {
                const filters = {
                    tag: {
                        field: 'tag',
                        value: this.tag
                    }
                }
                this.$api.getItems(this, 'help', filters, {})
                    .then((helps) => {
                        let text = null
                        if (helps && (helps.length === 1)) {
                            const help = helps[0]
                            this.id = help.id
                            this.text = help.content
                            text = help.content
                        }
                        this.$store.dispatch('submit', {
                            mutation: 'helps',
                            tag: this.tag,
                            text: text
                        })
                    })
            }
        }
    },
    methods: {
        edit () {
            if (this.canEdit) {
                if (this.id) {
                    const routeData = this.$router.resolve({ name: 'helpEdit', params: { helpId: this.id } })
                    window.open(routeData.href, this.tag)
                } else {
                    const routeData = this.$router.resolve({ name: 'helpCreate', query: { tag: this.tag } })
                    window.open(routeData.href, this.tag)
                }
            }
        },
    },
}
</script>

<style lang="scss">
.helper {
    margin-left: .25em;
}
</style>
